<div class="indicator"></div>
<div class="indicator"></div>
<div class="indicator"></div>
